var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 31,
    viewBox: "0 0 20 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2831 12.6965L13.3323 11.8316L10.6722 6.43868C10.5995 6.29102 10.48 6.17149 10.3323 6.09884C9.96199 5.91602 9.51199 6.06837 9.32684 6.43868L6.66668 11.8316L0.715901 12.6965C0.551838 12.7199 0.401838 12.7973 0.286995 12.9145C0.148155 13.0572 0.0716479 13.2492 0.0742847 13.4482C0.0769216 13.6473 0.158487 13.8372 0.301057 13.9762L4.60653 18.1738L3.58934 24.1012C3.56549 24.2391 3.58074 24.3809 3.63338 24.5105C3.68602 24.6402 3.77394 24.7525 3.88716 24.8347C4.00038 24.9169 4.13437 24.9658 4.27395 24.9758C4.41352 24.9857 4.5531 24.9564 4.67684 24.891L9.99949 22.0926L15.3222 24.891C15.4675 24.9684 15.6362 24.9941 15.7979 24.966C16.2057 24.8957 16.48 24.509 16.4097 24.1012L15.3925 18.1738L19.6979 13.9762C19.8151 13.8613 19.8925 13.7113 19.9159 13.5473C19.9792 13.1371 19.6932 12.7574 19.2831 12.6965Z",
    fill: "#FADB14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullStar);
export default __webpack_public_path__ + "static/media/full-star.ec3e2dec80a7e22e8d9b0d3599f7f802.svg";
export { ForwardRef as ReactComponent };